const transformSessionResponse = (item)=>{
    const componentName = item.component?.displayComponentName ?? '';
    if ('HOTEL_CARDS_MARKER' === componentName) return {
        content: '',
        role: '',
        date: new Date(item.date),
        displayComponentName: componentName,
        markerComponentProps: item.component?.markerComponentProps ?? '',
        vote: item.vote
    };
    return {
        content: item.content,
        role: item.role,
        date: new Date(item.date),
        displayComponentName: componentName,
        markerComponentProps: item.component?.markerComponentProps ?? '',
        vote: item.vote
    };
};
export { transformSessionResponse };
